module.exports = __webpack_public_path__ + "13547df9870bd4912f66534f19311b3e.svg";